import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useState, useEffect, useRef, useCallback } from 'react';
import { Helmet } from 'react-helmet-async';

const Home = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderRef = useRef(null);

  const slides = [

    {
      image: '/images/slider/slide1.jpg',
      brandLogo1: '',
      brandLogo2: '',
      title: 'Advanced Medical Gas Systems',
      specs: ['High Purity Gas', 'Integrated Monitoring'],
      price: 'Inquire Now',
      offer: 'Custom Solutions Available',
      bankOffer: '',
      exchangeOffer: '',
    },
    {
      image: '/images/slider/slide2.jpg',
      brandLogo1: '',
      brandLogo2: '',
      title: 'Advanced Medical Gas Systems',
      specs: ['High Purity Gas', 'Integrated Monitoring'],
      price: 'Inquire Now',
      offer: 'Custom Solutions Available',
      bankOffer: '',
      exchangeOffer: '',
    },
    {
      image: '/images/slider/slide3.jpg',
      brandLogo1: '',
      brandLogo2: '',
      title: 'Advanced Medical Gas Systems',
      specs: ['High Purity Gas', 'Integrated Monitoring'],
      price: 'Inquire Now',
      offer: 'Custom Solutions Available',
      bankOffer: '',
      exchangeOffer: '',
    },
    {
      image: '/images/slider/slide4.jpg',
      brandLogo1: '',
      brandLogo2: '',
      title: 'Advanced Medical Gas Systems',
      specs: ['High Purity Gas', 'Integrated Monitoring'],
      price: 'Inquire Now',
      offer: 'Custom Solutions Available',
      bankOffer: '',
      exchangeOffer: '',
    },
    // Add more slides here if needed
  ];

  const goToNextSlide = useCallback(() => {
    setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  }, [slides.length]);

  const goToPrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(() => {
      goToNextSlide();
    }, 5000); // Change slide every 5 seconds
    return () => clearInterval(interval);
  }, [goToNextSlide]);

  useEffect(() => {
    if (sliderRef.current) {
      const slideWidth = sliderRef.current.children[0].offsetWidth;
      sliderRef.current.scrollTo({
        left: currentSlide * slideWidth,
        behavior: 'smooth',
      });
    }
  }, [currentSlide]);

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Medical Gas Pipeline System (MGPS) | Hospital Build Pvt Ltd</title>
        <meta name="description" content="Hospital Build Pvt Ltd is a leading provider of Medical Gas Pipeline Systems (MGPS), Modular Operation Theatre Setup, Hospital Planning, and Turnkey Projects in India. Your trusted MGPS supplier and hospital equipment partner." />
        <meta name="keywords" content="Medical Gas Pipeline System, MGPS, Hospital Planning, Turnkey Projects, MGPS Supplier India, Modular Operation Theatre, Hospital Equipment Supplier, ICU Setup, Hospital Infrastructure, Medical Equipment India" />
        <link rel="canonical" href="https://www.hospitalbuild.in/" />
      </Helmet>
      {/* Horizontal Slider Section */}
      <section className="relative w-full overflow-hidden bg-gray-100 py-8" style={{ marginTop: '0px' }}>
        <div
          className="flex transition-transform duration-500 ease-in-out"
          style={{ transform: `translateX(-${currentSlide * 100}%)` }}
          ref={sliderRef}
        >
          {slides.map((slide, index) => (
            <div key={index} className="flex-shrink-0 w-full flex items-center justify-center relative">
              <img src={slide.image} alt={slide.title} className="w-full h-56 sm:h-72 md:h-96 lg:h-[400px] object-cover" />
              <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-40 px-2">
                <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold text-white mb-2 sm:mb-4 drop-shadow-lg text-center">
                  Empowering Healthcare, One Breath at a Time
                </h2>
                <p className="text-sm sm:text-lg md:text-2xl text-white font-medium drop-shadow text-center max-w-xs sm:max-w-lg md:max-w-2xl">
                  Discover the future of medical gas systems—engineered for purity, safety, and seamless care. Your patients deserve nothing less.
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Navigation Arrows */}
        <button
          onClick={goToPrevSlide}
          className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md focus:outline-none z-10"
        >
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button
          onClick={goToNextSlide}
          className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md focus:outline-none z-10"
        >
          <svg className="w-6 h-6 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>

        {/* Pagination Dots */}
        <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-3 h-3 rounded-full ${currentSlide === index ? 'bg-gray-800' : 'bg-gray-400'
                }`}
            />
          ))}
        </div>
      </section>
      {/* Hero Section */}
      <section className="relative bg-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="pr-8"
            >
              <h1 className="text-3xl md:text-5xl font-bold mb-6 text-[#2C2C90]">
                Hospital Planning & Designing
              </h1>
              <p className="text-gray-700 mb-8 text-lg">
                Through a meticulous review and strategic refinement process, we ensure that the architectural drawings align precisely with the intended concept brief, establishing a strong foundation for the project's seamless execution. All design parameters outlined in the Architect's brief are rigorously evaluated to comply with applicable Standards, Guidelines, Statutes, and Regulations, in full accordance with NQUAS, NABH, JCI, and other relevant global benchmarks. Whether referencing American, Australasian, or region-specific healthcare design standards, our objective remains clear: to deliver a thoughtfully planned healthcare facility that embodies excellence in quality, safety, functionality, and patient-centric care.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Layout and Space Planning</span>
                </div>
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Adherence to Health Facility Guidelines</span>
                </div>
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Compliance with NQUAS/NABH/JCI Standards</span>
                </div>
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Statutes, Rules, and Regulations</span>
                </div>
              </div>
              <Link
                to="/products"
                className="inline-block bg-[#2C2C90] text-white px-8 py-3 rounded hover:bg-[#1A1A5C] transition-colors"
              >
                View all products
              </Link>
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-xl overflow-hidden p-0 h-[400px] flex items-stretch"
            >
              <img
                src="/images/hpd.jpg"
                alt="Operation Room with Medical Gas Pipeline System"
                className="rounded-lg shadow-xl w-full h-[400px] object-contain bg-white"
              />
            </motion.div>

          </div>
        </div>
      </section>

      {/* From Plant Room to Patient Section */}
      <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 items-center">
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-xl overflow-hidden p-0 h-[400px] flex items-stretch"
            >
              <img
                src="/images/mot.jpg"
                alt="Medical Gas Plant Room"
                className="w-full h-full object-cover"
              />
            </motion.div>
            <div className="px-0 md:px-12">
              <h2 className="text-3xl md:text-4xl font-bold mb-6 text-[#2C2C90]">
                Modular Operation Theatre(MOT)
              </h2>
              <p className="text-gray-700 mb-8 text-lg">
                The Operation Theatre (OT) is the cornerstone of any hospital, playing a vital role in patient outcomes. It is a highly specialized environment designed not only to accommodate advanced life support systems but also to uphold the strictest infection control standards. Infection poses the greatest threat to surgical success, as procedures must breach the body's primary defense— the skin. This breach significantly increases a patient's vulnerability to external pathogens. Therefore, maintaining a sterile and meticulously controlled OT environment is critical to minimize infection risks and ensure safe, successful surgical interventions. The OT truly defines the hospital's commitment to excellence.
              </p>
              <button className="bg-[#2C2C90] text-white px-8 py-3 rounded-md hover:bg-[#1A1A5C] transition-colors">
                View catalogue
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="relative bg-white">
        <div className="container mx-auto px-4 py-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              className="pr-8"
            >
              <h1 className="text-3xl md:text-5xl font-bold mb-6 text-[#2C2C90]">
                Medical Gas Pipeline Specialists
              </h1>
              <p className="text-gray-700 mb-8 text-lg">
                World's leading provider of medical services and technology consultancy, specializing in Medical Gas Pipeline Systems (MGPS), Modular Operation Theaters (MOT), Nurse Call Systems (NCS), and more. We are committed to delivering high-quality, innovative solutions with a strong emphasis on safety, reliability, and customer satisfaction—empowering healthcare infrastructure with excellence across the globe.
              </p>
              <div className="grid grid-cols-2 gap-4 mb-8">
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>HTM 02-01 Compliant</span>
                </div>
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Technical Drawings</span>
                </div>
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>International standards</span>
                </div>
                <div className="flex items-center space-x-2">
                  <svg className="w-6 h-6 text-[#00B300]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                  <span>Testing & commissioning</span>
                </div>
              </div>
              <Link
                to="/products"
                className="inline-block bg-[#2C2C90] text-white px-8 py-3 rounded hover:bg-[#1A1A5C] transition-colors"
              >
                View all products
              </Link>
            </motion.div>
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              className="bg-white rounded-lg shadow-xl overflow-hidden p-0 h-[400px] flex items-stretch"
            >
              <img
                src="/images/mgps.jpg"
                alt="Operation Room with Medical Gas Pipeline System"
                className="rounded-lg shadow-xl w-full h-[400px] object-contain bg-white"
              // className="rounded-lg shadow-xl w-full h-[400px] object-cover"
              />
            </motion.div>

          </div>
        </div>
      </section>

      {/* Our Services Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-[#2C2C90]">Our Services</h2>
            <p className="text-gray-700 max-w-3xl mx-auto">
              Hospital Build offers a complete end-to-end solution for medical gas pipeline systems. Our dedicated sales and customer service team is here to guide you through the entire process, from initial consultation to order placement.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Modular Operation Theatre (MOT)',
                description: 'A Modular Operation Theatre (MOT) is a sterile, pre-fabricated surgical environment designed for efficiency, infection control, and patient safety.',
                image: '/images/services/mot.jpg',
                link: '/services/modular-ot'
              },
              {
                title: 'Central Sterile Supply Dept (CSSD)',
                description: 'The Central Sterile Supply Department (CSSD) ensures sterilization, storage, and distribution of medical instruments, critical for infection control.',
                image: '/images/services/cssd.png',
                link: '/services/cssd'
              },
              {
                title: 'Medical Gas pipeline system (MGPS) with LMO Tank and Vaporizer',
                description: 'Medical Gas Pipeline System (MGPS) with LMO tank and vaporizer ensures continuous, safe oxygen supply to critical hospital areas and patients.',
                image: '/images/services/mgps-lmo.jpg',
                link: '/services/mgps'
              },
              {
                title: 'Nursing Call System (NCS)',
                description: 'The Nursing Call System (NCS) enables patients to quickly communicate with nursing staff, ensuring timely assistance and enhanced patient safety.',
                image: '/images/services/ncs.png',
                link: '/services/ncs'
              },
              {
                title: 'Pneumatic Tube System (PTS)',
                description: 'A Pneumatic Tube System (PTS) transports materials swiftly through tubes using air pressure, enhancing efficiency in hospitals and laboratories.',
                image: '/images/services/pts.png',
                link: '/services/pts'
              },
              {
                title: 'Modular ICU',
                description: 'A Modular ICU is a prefabricated, scalable, and rapidly deployable critical care unit designed for efficient, safe, and high-quality patient care.',
                image: '/images/services/m-icu.jpg',
                link: '/services/modular-icu'
              }
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
                viewport={{ once: true }}
                className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow"
              >
                <div className="p-6 flex flex-col h-full">
                  <div className="mb-6">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-48 object-contain bg-white"
                    />
                  </div>
                  <h3 className="text-xl font-bold mb-3 text-[#2C2C90]">{service.title}</h3>
                  <p className="text-gray-600 mb-4 flex-grow">{service.description}</p>
                  <Link
                    to={service.link}
                    className="text-[#2C2C90] font-semibold hover:text-[#00B300] transition-colors inline-flex items-center"
                  >
                    Learn More
                    <svg className="w-5 h-5 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </Link>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Latest Articles Section */}
      {/* <section className="bg-gray-50 py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center text-[#2C2C90]">Our Latest Projects</h2>
          <LatestProjectsSlider />
        </div>
      </section> */}

      {/* Why Choose Us Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="text-4xl font-bold text-center text-[#2C2C90] mb-12"
          >
            Why Choose Us?
          </motion.h2>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="prose prose-lg max-w-none"
          >
            <p className="text-gray-700 mb-6">
              <span className="font-semibold">Hospital Build</span> (formerly Hospital Build) is one of the leading suppliers of <span className="font-semibold">Medical Gas Pipeline Systems (MGPS)</span>. Our company has extensive technical expertise and professional skills in designing, developing, and delivering specialized Medical Gas Pipeline Systems (MGPS) products for the Medical & Healthcare Domain.
            </p>

            <p className="text-gray-700 mb-6">
              We undertake the design and development of MGPS products for specialized applications, ensuring high levels of precision engineering, and maintaining consistent quality. Our state-of-the-art facility, combined with our focus on continuous improvement, enables us to deliver innovative and reliable MGPS products.
            </p>

            <p className="text-gray-700">
              Our vision is to develop sustainable and resilient systems that not only enhance healthcare delivery but also uplift the communities they serve.
              We are committed to designing healthcare infrastructure that is inclusive, user-friendly, and rooted in local architectural identity—while integrating modern technologies and state-of-the-art facilities.
              By blending cultural relevance with innovation, we aim to create healthcare environments that are both functional and inspiring.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Certificates Section */}
      {/* <Certificates /> */}

      {/* Our Clients Section */}
      {/* <section className="bg-[#f7f9fb] py-16">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold text-center mb-8 text-[#2C2C90]">
            Our Clients
            <div className="w-24 h-1 bg-blue-500 mx-auto mt-2 rounded" />
          </h2>
          <ClientsSlider />
        </div>
      </section> */}
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
function LatestProjectsSlider() {
  const articles = [
    {
      title: 'New Mother & Child Hospital Block, SCB Medical College, Cuttack No. of Beds:  585 Bedded Hospita',
      image: '/images/projects/mch-p1.jpg',
    },
    {
      title: 'New Super Specialty Hospital Blocks Madipur, Delhi No. of Beds:  750 Bedded Hospital',
      image: '/images/projects/madipur-p2.jpg',
    },
    {
      title: 'AIIMS Avantipora No. of Beds:  1912 Bedded Hospital',
      image: '/images/projects/avantipora-p2.jpg',
    },
    {
      title: 'All India Institute of Medical Sciences (AIIMS), Delhi No. of Beds:   2000 Bedded Hospital',
      image: '/images/projects/aiims-delhi-p2.png',
    },
    {
      title: 'Guru Gobind Singh Govt. Hospital Raghubir Nagar, Delhi No. of Beds:  472 Bedded Hospital',
      image: '/images/projects/gobind-p2.png',
    },
    {
      title: 'Redevelopment of AHPGI Cancer Hospital, Cuttack No. of Beds:  750 Bedded Hospital',
      image: '/images/projects/ahpgic-p2.jpg',
    },
    {
      title: 'AIIMS DARBHANGA HOSPITAL No. of Beds: 1000 Bedded Hospital',
      image: '/images/projects/aiims-darbhanga.jpg',
    }
  ];
  const [current, setCurrent] = React.useState(0);
  // Responsive visibleCount
  const [visibleCount, setVisibleCount] = React.useState(4);

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) setVisibleCount(1);
      else if (window.innerWidth < 1024) setVisibleCount(2);
      else setVisibleCount(4);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slideCount = articles.length;
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slideCount);
    }, 3000);
    return () => clearInterval(interval);
  }, [slideCount]);

  // To create an infinite loop effect, duplicate the articles array
  const extendedArticles = [...articles, ...articles.slice(0, visibleCount)];

  return (
    <div className="relative w-full overflow-x-auto scrollbar-none" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
      <style>{`
        .scrollbar-none::-webkit-scrollbar { display: none; }
      `}</style>
      <div
        className="flex transition-transform duration-500"
        style={{ transform: `translateX(-${current * (100 / visibleCount)}%)` }}
      >
        {extendedArticles.map((article, idx) => (
          <div
            key={idx}
            className="flex-shrink-0 px-2 w-full sm:w-1/2 lg:w-1/4 flex flex-col items-center justify-start"
            style={{ minWidth: visibleCount === 1 ? '100%' : visibleCount === 2 ? '50%' : '25%' }}
          >
            <div className="w-full h-48 sm:h-56 rounded-lg shadow overflow-hidden mb-4">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-base sm:text-lg font-bold text-[#2C2C90] text-center break-words whitespace-pre-line">
              {article.title}
            </h3>
          </div>
        ))}
      </div>
    </div>
  );
}

// eslint-disable-next-line no-unused-vars
function ClientsSlider() {
  const clients = [
    // { image: '/images/clients/cpwd-logo.jpg', alt: 'MN Logo' },
    { image: '/images/clients/fortis-logo.png', alt: 'HKSD Health City' },
    { image: '/images/clients/max-logo.png', alt: 'Hands with Globe' },
    { image: '/images/clients/medanta-logo.jpg', alt: 'PWD Delhi Government' },
    { image: '/images/clients/pwd-logo.jpg', alt: 'DDF Consultants Private Limited' },
    { image: '/images/clients/up-logo.png', alt: 'DDF Consultants Private Limited' },
  ];
  const [current, setCurrent] = React.useState(0);
  const [visibleCount, setVisibleCount] = React.useState(4);

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 640) setVisibleCount(1);
      else if (window.innerWidth < 1024) setVisibleCount(2);
      else setVisibleCount(4);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const slideCount = clients.length;
  React.useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slideCount);
    }, 3000);
    return () => clearInterval(interval);
  }, [slideCount]);

  // Infinite loop effect
  const extendedClients = [...clients, ...clients.slice(0, visibleCount)];

  return (
    <div className="relative w-full overflow-x-auto scrollbar-none" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
      <style>{`
        .scrollbar-none::-webkit-scrollbar { display: none; }
      `}</style>
      <div
        className="flex transition-transform duration-500"
        style={{ transform: `translateX(-${current * (100 / visibleCount)}%)` }}
      >
        {extendedClients.map((client, idx) => (
          <div
            key={idx}
            className="flex-shrink-0 px-2 w-full sm:w-1/2 lg:w-1/4 flex flex-col items-center justify-center"
            style={{ minWidth: visibleCount === 1 ? '100%' : visibleCount === 2 ? '50%' : '25%' }}
          >
            <img
              src={client.image}
              alt={client.alt}
              className="w-48 h-32 sm:w-60 sm:h-36 object-contain mb-2 bg-white rounded-lg shadow"
              style={{ maxHeight: 144 }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Home; 
